module.exports = __webpack_public_path__ + "static/media/launch_icon.6554d9f8.png";